import {useContext, useEffect, useState} from "react";
import ClientDataContext from "../store/client-data-context";

export const RPChooser = () => {

    const clientCtx = useContext(ClientDataContext);

    let [ageComparator, setAgeComparator] = useState(18);
    let [allMdlScopesSelected, setAllMdlScopesSelected] = useState(false);
    let [scopes, setScopes] = useState({
        "openid": true,
        "given_name": false,
        "family_name": false,
        "name": false,
        "age": false,
        "age_over": false,
        "age_under": false,
        "personal_code": false,
        "birthdate": false,
        "org.iso.18013.5.1:given_name": false,
        "org.iso.18013.5.1:family_name": false,
        "org.iso.18013.5.1:sex": false,
        "org.iso.18013.5.1:birth_date": false,
        "org.iso.18013.5.1:document_number": false,
        "org.iso.18013.5.1:issue_date": false,
        "org.iso.18013.5.1:issuing_country": false,
        "org.iso.18013.5.1:issuing_authority": false,
        "org.iso.18013.5.1:un_distinguishing_sign": false,
        "org.iso.18013.5.1:expiry_date": false,
        "org.iso.18013.5.1:driving_privileges": false,
        "org.iso.18013.5.1:portrait": false
    })

    useEffect(() => {
        localStorage.setItem('i18nextLng', 'en');
    })

    const selectClient = (event) => {
        localStorage.setItem('scopes', getSelectedScopes());
        localStorage.setItem('ageComparator', ageComparator.toString());
        clientCtx.changeClient(event.target.value);
    }

    const selectLang = (event) => {
        localStorage.setItem('i18nextLng', event.target.value);
    }

    const updateAgeComparator = (event) => {
        setAgeComparator(event.target.value);
    }

    const selectAllMdl = (event) => {
        let newScopes = scopes;
        Object.keys(newScopes)
            .filter(scope => scope.startsWith("org.iso.18013.5.1"))
            .map(scope => newScopes[scope] = event.target.checked);
        setScopes(newScopes);
        setAllMdlScopesSelected(event.target.checked);
    }

    const selectScope = (event) => {
        setScopes(scopes => ({
            ...scopes,
            [event.target.name]: event.target.checked
        }));

        if (!event.target.checked && event.target.name.startsWith("org.iso.18013.5.1")) {
            setAllMdlScopesSelected(false);
        }
    }

    const getSelectedScopes = () => {
        let selectedScopes = [];
        for (let scope of Object.keys(scopes)) {
            if (scopes[scope]) {
                selectedScopes.push(scope);
            }
        }
        return selectedScopes.join(" ");
    }

    return <>
        <div className="form-group">
            <label htmlFor="scopes">Scopes</label>
            <div id="scopes" className="scopes">
                {
                    Object.keys(scopes).filter(scope => !scope.startsWith("org.iso.18013.5.1")).map((scope, idx) => {
                        let id = "scope-" + scope;
                        return <div key={id}>
                            <label htmlFor={id}>{scope}</label>
                            <input type="checkbox" id={id} name={scope} checked={scopes[scope]} onChange={selectScope} />
                        </div>
                    })
                }
            </div>
        </div>
        <hr/>
        <div className="form-group">
            <label htmlFor="scopes">mDL Scopes</label>
            <div>
                <label htmlFor="mdl-select-all">Select all</label>
                <input type="checkbox" id="mdl-select-all" name="mdl-select-all" checked={allMdlScopesSelected} onChange={selectAllMdl} />
            </div>
            <div id="scopes" className="scopes">
                {
                    Object.keys(scopes).filter(scope => scope.startsWith("org.iso.18013.5.1")).map((scope) => {
                        let id = "scope-" + scope;
                        return <div key={id}>
                            <label htmlFor={id}>{scope}</label>
                            <input type="checkbox" id={id} name={scope} checked={scopes[scope]} onChange={selectScope} />
                        </div>
                    })
                }
            </div>
        </div>
        <hr/>
        <div className="form-group">
            <label htmlFor="age-comparator">Age comparator</label>
            <input type="number" className="form-control" id="age-comparator" value={ageComparator} onChange={updateAgeComparator}  />
        </div>
        <div className="form-group">
            <label htmlFor="langFormControlSelect1">Language select</label>
            <select className="form-control" id="langFormControlSelect1" onChange={selectLang} defaultValue=''>
                <option value='en'>english</option>
                <option value='et'>estonian</option>
                <option value='lv'>latvian</option>
            </select>
        </div>
        <div className="form-group">
            <label htmlFor="exampleFormControlSelect1">Demo client select</label>
            <select className="form-control" id="exampleFormControlSelect1" onChange={selectClient} defaultValue=''>
                <option disabled value=''> -- Select a client -- </option>
                <option>alco123</option>
                <option>bank321</option>
            </select>
        </div>
    </>


}
